import { GalaxyFilterDefinitionInterface, GalaxyFilterType, GalaxyFilterOperator } from '@vendasta/galaxy/filter/chips';
import { GalaxyColumnDef } from '@vendasta/galaxy/table';

export const FILTERS_EVENT_TYPE: GalaxyFilterDefinitionInterface[] = [
  {
    fieldId: 'name',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
    ],
    fieldName: 'Name',
  },
  {
    fieldId: 'bookingUrl',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
    ],
    fieldName: 'Link',
  },
  {
    fieldId: 'eventType',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
    ],
    fieldName: 'Event type',
  },
  {
    fieldId: 'teamName',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_EMPTY,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY,
    ],
    fieldName: 'Team name',
  },
  {
    fieldId: 'duration',
    type: GalaxyFilterType.FILTER_TYPE_INTEGER,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS_EQUAL_TO,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO,
    ],
    fieldName: 'Duration',
  },
];

export const FILTERS_GRP_AND_SVS: GalaxyFilterDefinitionInterface[] = [
  {
    fieldId: 'name',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
    ],
    fieldName: 'Name',
  },
  {
    fieldId: 'bookingUrl',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
    ],
    fieldName: 'Link',
  },
  {
    fieldId: 'description',
    type: GalaxyFilterType.FILTER_TYPE_STRING,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT,
      GalaxyFilterOperator.FILTER_OPERATOR_CONTAINS,
      GalaxyFilterOperator.FILTER_OPERATOR_DOES_NOT_CONTAIN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_EMPTY,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_NOT_EMPTY,
    ],
    fieldName: 'Description',
  },
  {
    fieldId: 'eventCount',
    type: GalaxyFilterType.FILTER_TYPE_INTEGER,
    hasFilterOptions: true,
    supportedOperators: [
      GalaxyFilterOperator.FILTER_OPERATOR_IS_EQUAL_TO,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_GREATER_THAN_OR_EQUAL_TO,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN,
      GalaxyFilterOperator.FILTER_OPERATOR_IS_LESS_THAN_OR_EQUAL_TO,
    ],
    fieldName: 'Event Count',
  },
];

export const COLUMNS: GalaxyColumnDef[] = [
  {
    id: 'isPinned',
    sticky: false,
    sortable: true,
    title: 'Pinned to top',
  },
  {
    id: 'name',
    title: 'Name',
    sticky: true,
    sortable: true,
  },
  {
    id: 'eventCount',
    title: 'Member Count',
    sortable: false,
  },
  {
    id: 'bookingUrl',
    title: 'Link/Location',
  },
  {
    id: 'duration',
    title: 'Duration',
    sortable: true,
  },
  {
    id: 'eventType',
    title: 'Event type',
    sortable: true,
  },
  {
    id: 'teamName',
    title: 'Team Name',
    sortable: true,
  },
  {
    id: 'description',
    title: 'Description',
    sortable: true,
  },
  {
    id: 'actions',
    pinned: true,
    stickyEnd: true,
    sortable: false,
  },
];
